<mat-card>
  <mat-card-content>
    <glxy-form-field appearance="outline" class="memo">
      <glxy-label>
        {{ 'BILLING.INVOICE_PAGE.MEMO' | translate }}
      </glxy-label>
      <glxy-label-hint>
        {{ memoSubtitle | translate }}
      </glxy-label-hint>
      <textarea matInput rows="4" [readonly]="readOnly" [formControl]="memoControl"></textarea>
      @if (memoControl.invalid) {
        <mat-error>
          {{ 'BILLING.INVOICE_PAGE.MEMO_DESCRIPTION' | translate }}
        </mat-error>
      }
    </glxy-form-field>
  </mat-card-content>
</mat-card>
